module.exports = __webpack_public_path__ + "media/images/about/b1-d274d0cfe79329fa537ae16134909754.png";